import { Component, Input } from '@angular/core';

@Component({
    selector: 'tvcore-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {
	@Input()
	message: string;
}
